import { configureStore } from "@reduxjs/toolkit";
import { persistStore } from "redux-persist";
import { combineReducers } from "@reduxjs/toolkit";

import loginSlice from "./slices/auth/loginSlice";
import signupSlice from "./slices/auth/signupSlice";
import verifyOtpSlice from "./slices/auth/emailVerificationSlice";
import resendOtpSlice from "./slices/auth/resendOtpSlice";
import kycVerifyOtpSlice from "./slices/auth/kycVerificationSlice";
import getProfileSlice from "./slices/profile/fetchProfileSlice";
import getProfileKycSlice from "./slices/profile/fetchKycProfileSlice";
import editProfileSlice from "./slices/profile/updateProfileSlice";
import signoutSlice from "./slices/auth/signoutSlice";
import addKYCSlice from "./slices/auth/kyc-management/addKycSlice";
import resendOtpKYCSlice from "./slices/auth/kyc-management/resendOtpKycSlice";
import verifyOtpKYCSlice from "./slices/auth/kyc-management/verifyOtpKycSlice";
import updateProfileSlice from "./slices/auth/kyc-management/updateProfileSlice";
import addBankDetailSlice from "./slices/wallet/addBankSlice";
import getBankDetailSlice from "./slices/wallet/fetchBankDetailSlice";
import deleteBankDetailSlice from "./slices/wallet/removeBankDetailSlice";
import loginGoogleSlice from "./slices/auth/loginGoogleSlice";
import configSlice from "./slices/auth/configSlice";
import generalConfigSlice from "./slices/auth/generalConfigSlice";
import locationReducer from "./slices/auth/locationSlice";
import getAllNotificationSlice from "./slices/notification/getAllNotificationSlice";
import inAppNotificationSlice from "./slices/notification/inAppNotificationSlice";
import markSeenSlice from "./slices/notification/markSeenSlice";
import markSeenAllSlice from "./slices/notification/markSeenSlice";
import getReferralEarningSlice from "./slices/referralEarning/referralEarningSlice";
import getDreamCasinoGamesSlice from "./slices/games/casino/dreamCasinoGameListSlice";
import getCmsSlice from "./slices/auth/cmsSlice";
import getCmsFaqsSlice from "./slices/auth/cmsfaqSlice";
import checkUserSlice from "./slices/auth/checkUserSlice";
import getGameLinkSlice from "./slices/games/getGameListSlice";
import getLeaderboardSlice from "./slices/games/leaderboardSlice";
import getCasinoProfitLossBetsSlice from "./slices/bets/casinoBetsSlice";
import myCasinoBetsSlice from "./slices/bets/myBetsCasinoSlice";
import getBonusListSlice from "./slices/profile/fetchBonusSlice";
import updateBonusSlice from "./slices/profile/updateBonusStatusSlice";
import deleteUserSlice from "./slices/profile/deleteUserSlice";
import forgotPasswordSlice from "./slices/auth/forgotPasswordSlice";
import resetPasswordSlice from "./slices/auth/resetPasswordSlice";
import tournamentsListSlice from "./slices/tournaments/tournamentsListSlice";
import tournamentLeaderboardSlice from "./slices/tournaments/tournamentLeaderboardSlice";
import tournamentSocketSlice from "./slices/tournaments/tournamentSocketSlice";
import changePINSlice from "./slices/profile/changePINSlice";
import sendOTPSlice from "./slices/auth/profile-verification/sendOTPSlice";
import verifyProfileOTP from "./slices/auth/profile-verification/verifyOTPSlice";
import favoriteGameList from "./slices/games/gameFavorite/favoriteGameListSlice";
import fetchUserBalanceSlice from "./slices/profile/fetchUserBalanceSlice";
import rakebackPointsSlice from "./slices/rakeback/rakebackPointsSlice";
import getRakebacksSlice from "./slices/rakeback/rakebackslice";
import rakebackBadgesDataSlice from "./slices/rakeback/badgesDataSlice";
import tournamentPlaySlice from "./slices/tournaments/tournamentPlaySlice";
import tournamentJoinSlice from "./slices/tournaments/tournamentJoinSlice";
import freeBetsListSlice from "./slices/gifts/freeBetsListSlice";
import freeSpinsListSlice from "./slices/gifts/freeSpinListSlice";
import riskFreeBetsListSlice from "./slices/gifts/riskFreeBetSlice";
import giftCountsSlice from "./slices/gifts/giftCountsSlice";
import bonusSlice from "./slices/wallet/bonusSlice";
import {
  promotionCategoryReducer,
  promotionReducer,
} from "./slices/promotions/promotionSlice";
import getSportGameLinkSlice from "./slices/games/getSportGameSlice";
import transactionHistorySlice from "./slices/Transaction/historySlice";

const appReducer = combineReducers({
  login: loginSlice,
  loginGoogle: loginGoogleSlice,
  config: configSlice,
  generalConfig: generalConfigSlice,
  signup: signupSlice,
  verifyOtp: verifyOtpSlice,
  kycVerifyOtp: kycVerifyOtpSlice,
  resendOtp: resendOtpSlice,
  getProfile: getProfileSlice,
  getProfileKyc: getProfileKycSlice,
  editProfile: editProfileSlice,
  signout: signoutSlice,
  addKYC: addKYCSlice,
  resendOtpKYC: resendOtpKYCSlice,
  verifyOtpKYC: verifyOtpKYCSlice,
  updateProfile: updateProfileSlice,
  addBankDetail: addBankDetailSlice,
  getBankDetail: getBankDetailSlice,
  deleteBankDetail: deleteBankDetailSlice,
  location: locationReducer,
  getAllNotification: getAllNotificationSlice,
  inAppNotification: inAppNotificationSlice,
  markSeen: markSeenSlice,
  markSeenAll: markSeenAllSlice,
  getReferralEarning: getReferralEarningSlice,
  getDreamCasinoGames: getDreamCasinoGamesSlice,
  getCms: getCmsSlice,
  getCmsFaqs: getCmsFaqsSlice,
  checkUser: checkUserSlice,
  getGameLink: getGameLinkSlice,
  getLeaderboard: getLeaderboardSlice,
  getCasinoProfitLossBets: getCasinoProfitLossBetsSlice,
  myCasinoBets: myCasinoBetsSlice,
  getBonusList: getBonusListSlice,
  updateBonus: updateBonusSlice,
  deleteUser: deleteUserSlice,
  forgotPassword: forgotPasswordSlice,
  resetPassword: resetPasswordSlice,
  tournamentsList: tournamentsListSlice,
  tournamentLeaderboard: tournamentLeaderboardSlice,
  leaderboardHistory: tournamentSocketSlice,
  changePIN: changePINSlice,
  sendOTP: sendOTPSlice,
  verifyOTP: verifyProfileOTP,
  favoriteGameList: favoriteGameList,
  fetchUserBalance: fetchUserBalanceSlice,
  rakebackPoints: rakebackPointsSlice,
  getRakebacks: getRakebacksSlice,
  rakebackdata: rakebackBadgesDataSlice,
  getTournamentGames: tournamentPlaySlice,
  tournamentJoin: tournamentJoinSlice,
  freeBetsList: freeBetsListSlice,
  freeSpinsList: freeSpinsListSlice,
  riskFreeBetsList: riskFreeBetsListSlice,
  bonus: bonusSlice,
  promotion: promotionReducer,
  promotionCategory: promotionCategoryReducer,
  giftCounts: giftCountsSlice,
  getSportGameLink: getSportGameLinkSlice,
  transactionHistory: transactionHistorySlice,
});
const rootReducer = (state, action) => {
  if (action.type == "RESET_STATE") {
    state = undefined;
  }
  return appReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        serializableCheck: false,
        ignoredPaths: ["payload.headers"],
      },
    }),
});

export const persistor = persistStore(store);
